import React from "react";
import styled from "styled-components";

export default styled.div`
  display: block;
  margin-bottom: -10px;
  padding-top: 7px;

  @media print {
    display: none;
  }
`;



// WEBPACK FOOTER //
// ./src/components/tekst/Buttons.js